import { useTranslation } from 'react-i18next';
import { FooterContainer } from './Footer.style';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation('footer');
  return (
    <FooterContainer>
      <div>
        <Link to="/contato">
          Entre em contato
        </Link>
      </div>
      <div>
        <Link to="/gdpr">
          {t('footer.link')}
        </Link>
      </div>
    </FooterContainer>
  );
};

export default Footer;
